import { Col, Space, Typography } from 'antd';
import moment from 'moment';

const PrintFilterText = ({ availableFilters, searchParams }) => {
  return (
    <Col span={24}>
      <Space wrap={true}>
        {availableFilters.map((i) => {
          let value = searchParams.get(i.name);
          if (!value) return null;
          if (i.type === 'select') {
            value = i.values.find((j) => j.value === value)?.title || value;
            if (i.valueType === 'number') {
              value = i.values.find((j) => +j.value === +value)?.title || value;
            }
          } else if (i.type === 'date') {
            value = moment(value, i.format).format(i.showFormat);
          }
          return (
            <div key={i.name}>
              <Typography.Text strong>{i.title}: </Typography.Text>
              <Typography.Text>{value}</Typography.Text>
            </div>
          );
        })}
      </Space>
    </Col>
  );
};

export default PrintFilterText;
